import React from 'react';

import styles from './styles.css';

export const InstallmentItemSkeleton = () => {
  return <div className={styles.body} />;
};
